import { Injectable } from '@angular/core';
import { UserInterfaceDto } from '../interfaces/user-interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  public readonly currentUser$!: Observable<UserInterfaceDto>;

  private readonly userSubject$: BehaviorSubject<UserInterfaceDto> = new BehaviorSubject<UserInterfaceDto>({
    id: '',
    domainId: '',
    civility: '',
    firstName: '',
    lastName: '',
    email: '',
    createdAt: new Date(),
    roles: [],
    softwareAccess: [],
  });

  public constructor() {
    this.currentUser$ = this.userSubject$.asObservable();
  }

  public setCurrentUserData(user: UserInterfaceDto): void {
    const currentUser: UserInterfaceDto = {
      ...user,
      roles: user.roles || [],
    };

    this.userSubject$.next(currentUser);
  }
}
